export const buildOptionsOfEntity = <T, >(
  entityList: T[] | undefined,
  labelPropertyName: keyof T,
  valuePropertyName: keyof T,
  lang?: string,
) => {
  return entityList
    ? entityList.sort().map((entity: T) => {
      // @ts-ignore
      const label = String(lang && entity[labelPropertyName][lang] ? entity[labelPropertyName][lang] : entity[labelPropertyName]);
      // @ts-ignore
      const value = String(lang && entity[valuePropertyName][lang] ? entity[valuePropertyName][lang] : entity[valuePropertyName]);
      return { label, value };
    })
    : [];
};
